export interface RevealOptions {
    selector: string;
    root?: ParentNode;
    visibleClass?: string;
    threshold?: number;
}

export function initReveal(options: RevealOptions): void {
    const {
        selector,
        root = document,
        visibleClass = 'is-visible',
        threshold = 0.2
    } = options;

    const elements = Array.from(root.querySelectorAll<HTMLElement>(selector));
    if (!elements.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        elements.forEach(el => el.classList.add(visibleClass));
        return;
    }

    let observer: IntersectionObserver | null = null;

    const reveal = (target: HTMLElement): void => {
        target.classList.add(visibleClass);
        observer?.unobserve(target);
    };

    const revealVisibleInViewport = (): void => {
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        elements.forEach(element => {
            if (element.classList.contains(visibleClass)) {
                return;
            }

            const rect = element.getBoundingClientRect();
            if (rect.bottom >= 0 && rect.top <= viewportHeight) {
                reveal(element);
            }
        });
    };

    observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            reveal(entry.target as HTMLElement);
        });
    }, { threshold });

    elements.forEach(el => observer.observe(el));
    window.requestAnimationFrame(revealVisibleInViewport);
    window.setTimeout(revealVisibleInViewport, 150);
    window.addEventListener('hashchange', () => {
        window.setTimeout(revealVisibleInViewport, 80);
    });
}
